<template>
  <div class="ggtf-video-list">
    <div v-for="video in videoList" :key="video.id" class="ggtf-video-card">
      <!-- 视频封面 -->
      <div class="ggtf-video-cover">
        <img :src="video.img" :alt="video.title" class="ggtf-cover-image" />
        <div class="ggtf-video-overlay">
          <div class="ggtf-play-btn">
            <PlayCircleOutlined :style="{ fontSize: '52px', color: '#000' }" />
          </div>
          <div class="ggtf-duration">{{ video.content }}</div>
        </div>
      </div>

      <!-- 视频信息 -->
      <div class="ggtf-video-info">
        <div class="gg1box">
          <h3 class="ggtf-video-title">{{ video.title }}</h3>
          <div class="ggtf-activity-code">{{ $t('_ggtf._hdbm') }}: {{ video.code }}</div>

          <!-- 开始倒计时 -->
          <div class="ggtf-countdown" v-if="video.begin_seconds > 0">
            <div class="ggtf-countdown-timer">
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.begin.days }}</span>
              </div>
              <div class="ggtf-time-separator">{{ $t('_ggtf._tian') }}</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.begin.hours }}</span>
              </div>
              <div class="ggtf-time-separator">:</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.begin.minutes }}</span>
              </div>
              <div class="ggtf-time-separator">:</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.begin.seconds }}</span>
              </div>
            </div>
            <div class="ggtf-end-time">{{ $t('_ggtf._kssj') }}: {{ formatDate(video.begin_time) }}</div>
          </div>

          <!-- 结束倒计时 -->
          <div class="ggtf-countdown" v-if="video.end_seconds > 0">
            <div class="ggtf-countdown-timer">
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.end.days }}</span>
              </div>
              <div class="ggtf-time-separator">{{ $t('_ggtf._tian') }}</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.end.hours }}</span>
              </div>
              <div class="ggtf-time-separator">:</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.end.minutes }}</span>
              </div>
              <div class="ggtf-time-separator">:</div>
              <div class="ggtf-time-unit">
                <span class="ggtf-time-value">{{ video.end.seconds }}</span>
              </div>
            </div>
            <div class="ggtf-end-time">{{ $t('_ggtf._jssj') }}: {{ formatDate(video.end_time) }}</div>
          </div>

          <!-- 最低投资 -->
          <div class="ggtf-activity-code">{{ $t('_ggtf._zdtz') }}: ${{ video.price_min }}</div>
          <!-- 活动天数 -->
          <div class="ggtf-activity-code">{{ $t('_wdtg._hdts') }}: {{ video.days }} {{ $t('_ggtf._tian') }}</div>
          <!-- 购买信息 -->
          <div class="ggtf-purchase-info">
            <div class="ggtf-vip-requirement">{{ $t('_ggtf._ddvp', { a: video.level, b: video.pre_num }) }}</div>
          </div>

          <!-- 状态 -->
          <div class="ggtf-activity-code" v-if="video.status === 3">
            {{ $t('_ggtf._hdzt') }}:
            <div class="setbox tstiaoj">{{ $t('_ggtf._wks') }}</div>
          </div>
          <div class="ggtf-activity-code" v-if="video.status === 5">
            {{ $t('_ggtf._hdzt') }}:
            <div class="setbox zt-jxz">{{ $t('_ggtf._ycy') }}</div>
          </div>
        </div>

        <div v-if="video.status === 1">
          <!-- 操作按钮 -->
          <div class="ggtf-action-section" style="align-items: center; justify-content: flex-end">
            <button class="ggtf-buy-btn" :class="{ 'ggtf-disabled': video.status === 3 }" @click="onBuy(video)">{{ $t('_ggtf._qg') }}</button>
            <!-- <button class="ggtf-detail-btn" @click="showVideoDetail(video)">
                <i class="fas fa-info-circle"></i>
                详情
              </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="ggtf-load-more">
      <button class="ggtf-load-more-btn" @click="getList" v-if="hasMore">
        <i class="fas fa-spinner" v-if="loading"></i>
        {{ loading ? $t('_a._jzz') : $t('_a._jzgd') }}
      </button>
      <div class="ggtf-no-more" v-else>{{ $t('_ggtf._mygdl') }}</div>
    </div>
  </div>
  <!-- 视频详情弹窗 -->
  <adv-buy ref="buy" @success="onSuccess"></adv-buy>
</template>

<script>
import { PlayCircleOutlined } from '@ant-design/icons-vue'
import AdvBuy from '@/components/adv/AdvBuy.vue'
export default {
  name: 'AdDelivery',
  components: { PlayCircleOutlined, AdvBuy },
  data() {
    return {
      countdown: {
        days: '00',
        hours: '06',
        minutes: '27',
        seconds: '55'
      },
      loading: false,
      hasMore: true,
      page: 1,
      size: 4,
      videoList: []
    }
  },
  computed: {
    userVIPLevel() {
      return 2 // 模拟用户VIP等级
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    //购买版权
    onBuy(item) {
      let that = this
      this.$api.videoAdv
        .snapUp({
          id: item.id
        })
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning(res.msg)
            return
          }

          if (res.data.status == 1) {
            that.$message.warning(this.$t('_ggtf._qgrtd'))
            return
          }

          if (res.data.status == 2) {
            this.$refs.buy.open(item, res.data.code)
            return
          }
        })
        .catch(() => {})
    },
    onSuccess() {
      this.getList(1)
    },
    /**
     * 加载列表
     */
    getList(page = 0) {
      let that = this

      //重置
      if (page > 0) {
        this.videoList = []
        this.page = page
        this.hasMore = true
      }

      if (this.loading) {
        return
      }
      this.loading = true

      this.$api.videoAdv
        .getVideoAdvList({
          page: that.page,
          size: that.size
        })
        .then((res) => {
          that.loading = false
          that.page++
          if (res.data.length == 0) {
            that.hasMore = false
            return
          }

          //增加数据
          res.data.forEach((item) => {
            that.videoList.push(item)
          })

          if (res.data.length < that.size) {
            that.hasMore = false
          } else {
            that.hasMore = true
          }

          that.videoList.map((item) => {
            //计算还剩余多少天时分秒
            item.begin = {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
              expired: true
            }
            if (item.begin_seconds > 0) {
              item.begin = that.$common.formatTimeRemaining(item.begin_seconds)
            }

            item.end = {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
              expired: true
            }
            if (item.end_seconds > 0) {
              item.end = that.$common.formatTimeRemaining(item.end_seconds)
            }

            //计算进度
            //item.percent = ((item.sold / item.num) * 100).toFixed(0)
            console.log(item)
            if (item.begin_seconds > 0) {
              this.startCountdown(item, 'begin')
            } else if (item.end_seconds > 0) {
              this.startCountdown(item, 'end')
            }
          })
        })
    },
    startCountdown(item, key) {
      setInterval(() => {
        let time = item[key]
        // 模拟倒计时更新
        let seconds = parseInt(time.seconds)
        let minutes = parseInt(time.minutes)
        let hours = parseInt(time.hours)
        let days = parseInt(time.days)

        seconds--

        if (seconds < 0) {
          seconds = 59
          minutes--

          if (minutes < 0) {
            minutes = 59
            hours--

            if (hours < 0) {
              hours = 23
              days--
            }
          }
        }

        item[key] = {
          days: days.toString().padStart(2, '0'),
          hours: hours.toString().padStart(2, '0'),
          minutes: minutes.toString().padStart(2, '0'),
          seconds: seconds.toString().padStart(2, '0')
        }
      }, 1000)
    },

    formatDate(date) {
      return (
        new Date(date).toLocaleDateString('zh-CN') +
        ' ' +
        new Date(date).toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit'
        })
      )
    }
  }
}
</script>

<style></style>
